/* eslint-disable */
import Vue from 'vue';
import Router from 'vue-router';

// import steps
import Home from '@/components/pages/00_home';
import Building from '@/components/pages/01_building';
import Panel from '@/components/pages/02_panel';
import Options from '@/components/pages/03_options';
import Customer from '@/components/pages/04_customer';
import Summary from '@/components/pages/05_summary';


Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    {
        path: '/',
        name: 'Home',
        component: Home,
        props: {
            step: 0,
        },
    },
    {
        path: '/buildings',
        name: 'Buildings',
        component: Home,
        props: {
            step: 0,
        },
    },
    {
      path: '/:buildingAddress',
      name: 'Building',
      component: Building,
      props: {
        step: 1,
      },
    },
    {
      path: '/:buildingAddress/step-2',
      name: 'Panel',
      component: Panel,
      props: {
        step: 2,
      },
    },
    {
      path: '/:buildingAddress/step-3',
      name: 'Options',
      component: Options,
      props: {
        step: 3,
      },
    },
    {
      path: '/:buildingAddress/step-4',
      name: 'Customer',
      component: Customer,
      props: {
        step: 4,
      },
    },
    {
      path: '/:buildingAddress/summary',
      name: 'Summary',
      component: Summary,
      props: {
        step: 5,
      },
    },
    {
      path: '*',
      redirect: '/',
    },
  ],
});

router.afterEach((to, from) => {
  window.scrollTo(0, 0);
  // store.dispatch('UPDATE_STEPS', to.matched[0].props.default.step);
});

export default router;


// WEBPACK FOOTER //
// ./src/router/index.js